export default function SectionLabel({ children, className = "" }) {
  return (
    <div className={`flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.25em] text-terracotta ${className}`}>
      <span className="w-8 h-px bg-terracotta" />
      {children}
    </div>
  );
}
